export const ApiDeleteSpaceTag = Symbol('ApiDeleteSpaceTag');
